<template>
  <tr style="padding: 0px;">
    <td style="text-align: center;padding: 0px;"> {{ detail.idx + 1}} </td>

    <td style="padding: 0px;">
      <select class="form-control" v-model="detail.quality_id" @change="rowValueEqualizer(index, 1)">
        <option v-for="quality in qualities" v-bind:value="quality.id">
          {{ quality.name }}
        </option>
      </select>
    </td>
    <td style="padding: 0px;">
      <select class="form-control" v-model="detail.color_id" @change="rowValueEqualizer(index, 1)">
        <option v-for="color in colors" v-bind:value="color.id">
          {{ color.name }}
        </option>
      </select>
    </td>
    <td style="padding: 0px;">
      <select class="form-control" v-model="detail.size" >
        <option value="3x6.5">3 x 6.5</option>
        <option value="4x6.5">4 x 6.5</option>
        <option value="5x6.5">5 x 6.5</option>
        <option value="6x6.5">6 x 6.5</option>
        <option value="8x6">8 x 6</option>
        <option value="10x7.5">10 x 7.5</option>
      </select>
    </td>
    <td style="padding: 0px;text-align: right; ">
      <input class="form-control text-right" v-model="detail.qty" />
    </td>
    <td style="padding: 0px;text-align: right; ">
      <input class="form-control text-right" v-model="detail.weight" />
    </td>
    <td style="padding: 0px;text-align: right;width: 30px;">
      <button name="btnRemoveRow"   type="button" class="btn border-warning text-warning-600 btn-flat btn-icon btn-rounded legitRipple btnRemoveRow" @click="removeRow(index)" tabindex="-1" ><i class="icon-eraser"></i></button>
    </td>

  </tr>
</template>

<script>
  import moment from 'moment-timezone'
  import {userService} from '@/store/auth-header.js'
  export default {
    name: 'StitchingDetailRow',
    props: {
      myrow: {
        type: Object,
        default: () => JSON.parse('{"idx":0,"id":0,"qua_id":1,"col_id":1,"pcs":0,"weight":0,"quality":{"id":1,"name":""},"color":{"id":1,"name":""}}')
      },
      myindex: {
        type: Number,
        default: () => 0
      },
      qualities:{
        type: Array,
        default: () => new Array()
      },
      colors:{
        type: Array,
        default: () => new Array()
      },
    },
    beforeMount () {
      this.detail = this.myrow;
      this.index = this.myindex;
      this.detail.idx = this.myindex;

      // this.fabric.fabric.color =  this.fabric.color;
      // this.fabric.fabric.quality =  this.fabric.quality;
    },
    data () {
      return {
        index: 0,
        detail : JSON.parse('{"idx":0,"id":0,"qua_id":1,"col_id":1,"pcs":0,"weight":0,"quality":{"id":1,"name":""},"color":{"id":1,"name":""}}')
      }
    },
    filters:{
      weightFormat (val){
        return val.toFixed(3);
      }
    },
    methods:{
      removeRow(){
        this.$emit('onRemoveRow', Math.abs(this.$data.fabric.idx) );
      },
      rowValueEqualizer(col) {
        const self = this;
        let colIndex = -1;
        try {

          let detail = self.$data.detail;

          switch (col) {
            case 1: //Fab Code
              colIndex = 0;
              break;
            case 2: //Fab Button
              break;
            case 3: //Quality
              break;
            case 4: //Color
              break;
            case 5:  //Weight
              break;
          }
        }catch (e) {

        }
        self.$emit('onrow_change',self.myindex, colIndex, self.$data.fabric );
      },
      loadFabric(id){
        if(id < 1) {
          return;
        }

        const self = this;
        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        self.$data.detail = JSON.parse('{"idx":0,"id":0,"qua_id":1,"col_id":1,"pcs":0,"weight":0,"quality":{"id":1,"name":""},"color":{"id":1,"name":""}}');
        self.$data.detail.idx = self.myindex ;

        $('row').block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });


        fetch(`${process.env.VUE_APP_ROOT_API}api/knitting/receipt/${id}`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {

            if(!_.isNull(resp.data)){
              self.$data.fabric = resp.data;
              self.$data.fabric.idx = self.myindex ;
              self.$emit('on_fabric_add', self.$data.fabric);
            }
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error", onClose: () => { self.refs.fabcode.focus()}, timer:1500 } );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error", onClose: () => { self.refs.fabcode.focus()}, timer:1500 } );
        }).finally(function () {
          $('row').unblock();
        });
      },
    }
  }
</script>

<style scoped>
  input:focus {
    background: #feff00;

  }

  textarea:focus {
    background: #feff00;

  }

  select:focus {
    background: #feff00;
  }

  button:focus {
    background: #feff00;
    color: #0a0a0a!important;
  }
</style>
